// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__m7kAD","ant-page-header-heading-title":"styles_ant-page-header-heading-title__2o9gv","table":"styles_table__7SnnN"};